<template>
  <li>
    <div
      class="p-2 rounded-lg bg-fill-brand-secondary w-full flex flex-row justify-between items-center gap-1 min-h-16"
    >
      <div class="flex flex-col gap-1 ml-2 flex-1">
        <!-- Room title skeleton with # prefix -->
        <div class="flex items-center gap-1">
          <span class="text-text text-sm font-semibold">#</span>
          <Skeleton
            :width="titleWidths[index % titleWidths.length]"
            height="20px"
            border-radius="4px"
          />
        </div>

        <!-- Last message skeleton -->
        <div class="flex flex-row gap-0 items-center">
          <!-- Avatar skeleton -->
          <div class="mr-2">
            <Skeleton width="24px" height="24px" border-radius="50%" />
          </div>
          <!-- Message text skeleton -->
          <Skeleton
            :width="messageWidths[index % messageWidths.length]"
            height="16px"
            border-radius="4px"
          />
        </div>
      </div>

      <div class="flex flex-row gap-1 items-center">
        <!-- Badge skeleton (sometimes present) -->
        <div v-if="index % 3 === 0">
          <Skeleton width="24px" height="24px" border-radius="50%" />
        </div>
        <!-- Arrow icon skeleton -->
        <Skeleton width="24px" height="24px" border-radius="4px" />
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";

const _props = withDefaults(
  defineProps<{
    index?: number;
  }>(),
  {
    index: 0,
  },
);

// Different widths for variety
const titleWidths = ["120px", "90px", "140px", "100px", "110px"];
const messageWidths = ["150px", "180px", "130px", "160px", "140px"];
</script>
